import Divider from '@/components/ui/Divider';
import React from 'react';
import Icon from '@/components/ui/Icon';
import Text from '@/components/cms/Text';

type StaticLink = {
  link: {
    href: string;
    text: string;
    target?: string;
    rel?: string;
    ariaLabel?: string;
    onClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void;
  };
  image?: {
    url: string;
  };
};

const staticLinks: StaticLink[] = [
  {
    link: { href: '/support/disclaimer', text: 'Disclaimer' }
  },
  {
    link: { href: '/support/privacy-policy', text: 'Privacy policy' }
  },
  {
    link: { href: '/support/terms-of-use', text: 'Terms of use' }
  },
  {
    link: {
      href: '#',
      text: 'Your privacy choices',
      onClick: e => {
        e.preventDefault();
        if (typeof window.truste !== 'undefined' && window.truste.eu) {
          window.truste.eu.clickListener();
        } else {
          // Fallback: simulate click on the anchor inside #teconsent
          try {
            const teconsent = document.getElementById('teconsent');
            if (teconsent) {
              const anchor = teconsent.querySelector('a[role="link"]');
              if (anchor) {
                (anchor as HTMLElement).click();
              }
            }
          } catch (err) {
            // Optionally log or ignore
            console.error(err);
          }
        }
      }
    }
  }
];

export const StaticFooterFallback = React.memo(function StaticFooterFallback() {
  const currentYear = new Date().getFullYear();
  return (
    <footer className="bg-charcoal py-16 text-white lg:py-20">
      <div className="container">
        <Divider color="darker" />
        <div className="flex flex-col gap-8 pt-8 text-silver md:flex-row md:items-center md:justify-between">
          <nav className="text-2 flex flex-wrap gap-3 font-medium md:justify-end md:gap-x-8">
            <ul
              className="flex flex-wrap gap-3 md:gap-x-8"
              data-component={'FooterBlock-bottomLinks'}
            >
              {staticLinks.map((link, idx) => {
                if (!link) return null;
                return (
                  <li key={idx}>
                    <a
                      href={link.link?.href}
                      onClick={link.link?.onClick}
                      className="flex items-center gap-2 hover:underline"
                      target={link.link?.target || undefined}
                      rel={link.link?.rel || undefined}
                      aria-label={link.link?.ariaLabel || undefined}
                    >
                      {link.link?.text}
                      {link.link?.text === 'Your privacy choices' ? (
                        <Icon name="privacyoptions" size="small" className="align-middle" />
                      ) : link.image ? (
                        <img
                          src={link.image.url}
                          alt={link.link?.text}
                          className="size-4 align-middle"
                        />
                      ) : null}
                    </a>
                  </li>
                );
              })}
            </ul>
            <Text propertyName="Copyright">
              &copy; 1996-{currentYear} Practising Law Institute.
            </Text>
          </nav>
        </div>
      </div>
    </footer>
  );
});
